import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../mfe/MfeLoader";
import { getAgentHostConfig } from "../config/agentHostConfig";
import { useHostNavigate } from "../hooks/useHostNavigate";

export const Route = createFileRoute("/agent/$")({
  component: AgentMfePage,
});

function AgentMfePage() {
  const onNavigate = useHostNavigate();
  return (
    <MfeLoader
      name="agent"
      props={{ hostConfig: getAgentHostConfig(onNavigate) }}
    />
  );
}
